import _get from 'lodash/get';

export const getChangedPropertiesByKeys = ({ data, keys }) => {
  return keys.reduce((properties, propertyKey) => {
    properties[propertyKey] = _get(data, propertyKey);

    return properties;
  }, {});
};
